import React, { useState, useEffect } from "react";

import { Editor } from "primereact/editor";
import { Button } from 'primereact/button';

import Quill from 'quill';
import axios from './axios'

const TextEditor = ({setBlocked, toast, sendMessage, notification, editable }) => {
    const [text, setText] = useState('');

    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
		if (notification.type === "editor_saved") {
			fetchData()
			toast.current.show({ severity: 'info', summary: 'Info', detail: `Editor changed!`, life: 3000 });
		}
	}, [notification])

	const fetchData = async () => {
		setBlocked(true);
		try {
			const response = await axios.get('/editor');
			setText(response.data[0].text);
		} catch (err) {
			toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to get editor text!', life: 3000 });
		}
		setBlocked(false);
	};

	const saveEditor = async () => {
		setBlocked(true);
		try {
			const response_message = await axios.post('/editor/edit', { text: text ?? "" });
			if (response_message.data.success) {
				sendMessage(JSON.stringify({ type: "editor_saved" }))
				toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Editor saved!', life: 3000 });
			}
			else {
				toast.current.show({ severity: 'error', summary: 'Error', detail: 'Editor failed to save!', life: 3000 });
			}
		}
		catch (error) {
			toast.current.show({ severity: 'error', summary: 'Error', detail: 'Editor failed to save!', life: 3000 });
		}
		setBlocked(false);
	}

    var Size = Quill.import('attributors/style/size');
    Size.whitelist = ['10px', '16px', '24px', '32px', '48px', '64px', '72px'];
    Quill.register(Size, true);

    const toolbar = () => {
        return (
            <>
                <span className="ql-formats">
                    <select className="ql-font"></select>
                    <select title="Size" className="ql-size" value={"32px"}>
                        <option value="10px">10px</option>
                        <option value="16px">16px</option>
                        <option value="24px">24px</option>
                        <option value="32px">32px</option>
                        <option value="48px">48px</option>
                        <option value="64px">64px</option>
                        <option value="72px">72px</option>
                    </select>
                </span>
                <span className="ql-formats">
                    <button className="ql-bold" aria-label="Bold"></button>
                    <button className="ql-italic" aria-label="Italic"></button>
                    <button className="ql-underline" aria-label="Underline"></button>
                    <button className="ql-strike" aria-label="Strike"></button>
                </span>
                <span className="ql-formats">
                    <select className="ql-color"></select>
                </span>
                <span className="ql-formats">
                    <button className="ql-list" value="ordered"></button>
                    <button className="ql-list" value="bullet"></button>
                    <select className="ql-align"></select>
                </span>
                <span className="ql-formats">
                    <button className="ql-image"></button>
                </span>
            </>
        );
    };

    const renderToolbar = toolbar()

    return (
        <>
            <Editor headerTemplate={renderToolbar} value={text} onTextChange={(e) => setText(e.htmlValue)} style={{ flex: "1 1 0px" }} className="flex flex-column relative" onLoad={(e) => e.root.setAttribute("spellcheck", "false")} readOnly={(!editable)} showHeader={editable}/>
            {editable && <Button label="Save editor" icon="pi pi-save" className="absolute top-0 right-0 m-3" onClick={saveEditor} />}
        </>
    );
}

export default TextEditor;